module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/abIqRP/tc-custom/9780226321288.jpg?1722571967859",
      "alt": "This image is the cover for the book New Studies in Philosophy, Politics, Economics and the History of Ideas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Studies in Philosophy, Politics, Economics and the History of Ideas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a Nobel Laureate economist, a collection of essays outlining ideas on political theory, economic freedom and epistemology.")]), _c('br'), _c('br'), _vm._v("Following on F. A. Hayek’s previous work "), _c('i', [_vm._v("Studies in Philosophy, Politics, and Economics ")]), _vm._v("(1967), "), _c('i', [_vm._v("New Studies in Philosophy, Politics, Economics and the History of Ideas")]), _vm._v(" collects some of Hayek’s most notable essays and lectures dealing with problems of philosophy, politics and economics, with many of the essays falling into more than one of these categories. Expanding upon the previous volume the present work also includes a fourth part collecting a series of Hayek’s writings under the heading “History of Ideas.”"), _c('br'), _c('br'), _vm._v("Of the articles contained in this volume the lectures on “The Errors of Constructivism”and “Competition as a Discovery Procedure” have been published before only in German, while the article on “Liberalism” was written in English to be published in an Italian translation in the "), _c('i', [_vm._v("Enciclopedia del Novicento")]), _vm._v(" by the Istituto della Enciclopedia Italiana at Rome.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. A. Hayek\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0